export default __webpack_public_path__ + "static/media/opera.0747abdb.webp";